import { render, staticRenderFns } from "./PracticeMultiSelectInput.vue?vue&type=template&id=48e5183a"
import script from "./PracticeMultiSelectInput.vue?vue&type=script&lang=js"
export * from "./PracticeMultiSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports